import request from '@/utils/request'
export const expenseOptions = () =>
  request({ url: '/crmExpenseClaim/options', method: 'get' })
export const expenseList = (data) =>
  request({ url: '/crmExpenseClaim/list', method: 'post', data })
export const expenseDetail = (id) =>
  request({ url: `/crmExpenseClaim/detail/${id}`, method: 'get' })
export const expenseTargets = (params) =>
  request({ url: '/crmExpenseClaim/targets', method: 'get', params })
export const saveExpense = (data) =>
  request({ url: '/crmExpenseClaim/save', method: 'post', data })
export const submitExpense = (data) =>
  request({ url: '/crmExpenseClaim/submit', method: 'post', data })
export const previewExpenseApproval = (data) =>
  request({ url: '/crmExpenseClaim/approval-preview', method: 'post', data })
export const withdrawExpense = (data) =>
  request({ url: '/crmExpenseClaim/withdraw', method: 'post', data })
export const payExpense = (data) =>
  request({ url: '/crmExpenseClaim/payment', method: 'post', data, expensePayment: true })
export const expenseCompanies = () =>
  request({ url: '/crmExpenseClaim/companies', method: 'get' })
export const saveExpenseCompany = (data) =>
  request({ url: '/crmExpenseClaim/company/save', method: 'post', data })
export const saveExpenseConfig = (data) =>
  request({ url: '/crmExpenseClaim/config/save', method: 'post', data })
export const exportExpenses = (data) =>
  request({
    url: '/crmExpenseClaim/export',
    method: 'post',
    data,
    responseType: 'blob',
  })

export const expenseProducts = (params) =>
  request({ url: '/crmExpenseClaim/products', method: 'get', params })
export const expenseBeneficiary = (id) =>
  request({ url: `/crmExpenseClaim/beneficiary/${id}`, method: 'get' })

export const expenseContacts = (params) => request({ url: '/crmExpenseClaim/contacts', method: 'get', params })
export const analyzeExpense = (data) => request({ url: '/crmExpenseClaim/analysis', method: 'post', data, timeout: 40000 })

export const expensePaymentSummary = () => request({ url: '/crmExpenseClaim/payment-summary', method: 'get', silent: true })

export const expenseSubmissionAccess = () => request({ url: '/crmExpenseClaim/submission-access', method: 'get', silent: true })
